import { render, staticRenderFns } from "./PanelCompetitionSettingStoperMainFullscreen.vue?vue&type=template&id=0fa7bc6e&"
import script from "./PanelCompetitionSettingStoperMainFullscreen.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoperMainFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa7bc6e')) {
      api.createRecord('0fa7bc6e', component.options)
    } else {
      api.reload('0fa7bc6e', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingStoperMainFullscreen.vue?vue&type=template&id=0fa7bc6e&", function () {
      api.rerender('0fa7bc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingStoperMainFullscreen.vue"
export default component.exports